var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Card = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  background-color: #242424;\n  margin: 8px;\n  padding: 16px;\n"], ["\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  background-color: #242424;\n  margin: 8px;\n  padding: 16px;\n"])));
var templateObject_1;
//# sourceMappingURL=card.js.map